import React from "react";
import { BiRightArrow } from "react-icons/bi";
import { AiFillCaretRight } from "react-icons/ai";
import { BsCheck } from "react-icons/bs";
const WStepper = ({ classes, currentTab, config }) => {

  return (
    <>
      <div className="space-x-4 md:space-x-8 flex fonbold justify-center w-full">
        {config?.map((step, stepIndex) => {
          return (
            <div
              key={`${stepIndex}-stepper`}
              className="flex space-x-3 cursor-pointer items-center"
            >
              <div
                className={`${
                  +stepIndex + 1 === +currentTab
                    ? "bg-white border-primary border"
                    : 'bg-gray-300 text-black" : "bg'
                }
                   ${
                     currentTab > stepIndex + 1
                       ? "bg-primary text-black"
                       : "none"
                   }
                  rounded-full h-10 w-10 flex items-center justify-center flex-shrink-0 self-center`}
              >
                {currentTab > stepIndex + 1 ? (
                  <BsCheck size={32} className="text-white" />
                ) : (
                  stepIndex + 1
                )}
              </div>
              <div className="flex space-x-3 items-center">
                <div
                  className={`hidden md:block uppercase self-center ${
                    currentTab > stepIndex + 1
                      ? "text-primary"
                      : currentTab === stepIndex + 1
                      ? "text-primary font-medium"
                      : ""
                  }`}
                  name={`${stepIndex + 1}  ${config.length}`}
                >
                  {step?.name} 
                </div>
                    
                {stepIndex + 1 === config.length 
                ? ""
                :  currentTab >= stepIndex + 1 
                ? (<AiFillCaretRight fill="#009FE3" />) 
                : (<BiRightArrow className="text-gray-500" />)
                }

              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default WStepper;
